import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { SingleDatePicker, SecurityHelper, Icons, Button, TYPES } from 'sarsaparilla';
import moment from 'moment';
import { MT_WHITNEY_PERMIT_ID } from '../../utils/inyoUtils';
import { RES_ID_DELIMITER, AVAILABILITY_KEY_MAP_FORMAT } from '../../constants';
import * as utils from '../../utils/availabilityUtils';

class MtWhitneyDayUsePermit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      date: null,
      isLotteryOpen: null,
      isFutureLottery: null,
      lotteryIsClosed: null,
      dateWithinSeason: null
    };
    this.setPermitType = this.setPermitType.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
  }

  onDateChange(date) {
    this.setState({ date });
    const currentDate = moment().utc();
    let lotteryIsClosed = null;
    let isLotteryOpen = null;
    let isFutureLottery = null;
    const dateWithinSeason = utils.isDayWithinSeason(date, { permit: this.props.permit });

    let lotteryStart;
    let lotteryEnd;
    let lotteryDisplayDate;
    const lottery = this.getActiveLottery();
    if (lottery) {
      lotteryStart = moment(lottery.open_at);
      lotteryEnd = moment(lottery.close_at);
      lotteryDisplayDate = moment(lottery.display_at);
    }

    if (dateWithinSeason === true) {
      if (!lotteryStart || !lotteryEnd) {
        lotteryIsClosed = true;
      }
      else {
        isLotteryOpen = currentDate.isBetween(lotteryStart, lotteryEnd, 'seconds', '[]');
        isFutureLottery = currentDate.isBetween(lotteryDisplayDate, lotteryStart, 'seconds', '[]');
        lotteryIsClosed = (isLotteryOpen === false && isFutureLottery === false);
      }
    }

    this.setState({
      isLotteryOpen,
      isFutureLottery,
      lotteryIsClosed,
      dateWithinSeason
    });
  }

  setPermitType(target, needAuth) {
    if (target) {
      if (needAuth) {
        const loggedIn = SecurityHelper.isLoggedIn();
        if (!loggedIn) {
          this.props.pActions.showLoginModal();
          return;
        }

        if (this.state.isLotteryOpen) {
          window.location.assign(target);
          return;
        }
        this.props.history.push(target);
      }
      else {
        if (this.state.isLotteryOpen) {
          window.location.assign(target);
          return;
        }
        this.props.history.push(target);
      }
    }
  }

  getActiveLottery() {
    const { lotteries } = this.props;
    if (lotteries) {
      return lotteries.find((lt) => lt.status === "LotteryStatusActive" && moment(lt.open_at).isBefore(moment()) && moment(lt.close_at).isAfter(moment()));
    }
    return null;
  }

  getLotteryLink() {
    const lottery = this.getActiveLottery()
    if (lottery) {
      return `/permits/${MT_WHITNEY_PERMIT_ID}/lottery/${lottery.id}/registration/${RES_ID_DELIMITER}${MT_WHITNEY_PERMIT_ID}`;
    }
    return "";
  }

  getSingleDatePickerFormElementProps() {
    return {
      id: "SingleDatePicker2",
      date: this.state.date,
      numberOfMonths: 1,
      focused: this.state.focused,
      showDefaultInputIcon: true,
      onDateChange: this.onDateChange,
      onFocusChange: ({ focused }) => this.setState({ focused })
    };
  }

  render() {
    let buttonIsDisabled = true;
    let needAuth = false;
    let buttonLabel = "Check Availability";
    let result = null;
    let target = null;
    if (this.state.dateWithinSeason === false) {
      result = (
        <p>Your entry date falls outside the <b>quota season</b>. Contact Inyo National Forest office for details on the best way to acquire a permit.</p>
      );
    }
    else if (this.state.isFutureLottery === true) {
      buttonLabel = 'Home Page';
      target = `/permits/${MT_WHITNEY_PERMIT_ID}`;
      buttonIsDisabled = false;
      result = (
        <p><b>Enter the Mt Whitney lottery</b> to attempt to get a permit award.
        <br />
          The lottery isn’t open yet, but you can discover those details by reading the Lottery Information section on the main page of this permit.
        </p>
      );
    }
    else if (this.state.isLotteryOpen === true) {
      buttonLabel = 'Enter Lottery';
      needAuth = true;
      buttonIsDisabled = false;
      target = this.getLotteryLink();
      result = (
        <p><b>Enter the Mt Whitney lottery</b> to attempt to get a permit award.
        <br />
          The lottery is open.
        </p>
      );
    }
    else if (this.state.lotteryIsClosed === true) {
      const date = this.state.date ? this.state.date.format(AVAILABILITY_KEY_MAP_FORMAT) : null;
      target = `/permits/${MT_WHITNEY_PERMIT_ID}/registration/detailed-availability?date=${date}`;
      buttonIsDisabled = false;
      result = (
        <p><b>You must obtain a permit</b> for the day you are entering;
          click below to view availability.
        </p>
      );
    }


    return (
      <div>
        <h3 className="rec-questionnaire-result-what-you-need">
          You will need a...
        </h3>
        <div className="rec-questionnaire-result-title">
          Mt Whitney Day Use Permit
        </div>

        <div className="rec-questionnaire-result-icon">
          <Icons.IconPermit />
        </div>

        <p>
          You will need a Mt Whitney Day Use Permit for the day of your trip.
        </p>

        <div className="rec-form-item-wrap">
          <label htmlFor="SingleDatePicker2">
            Desired entry date
          <SingleDatePicker id="date"{...this.getSingleDatePickerFormElementProps()} />
          </label>
        </div>

        <div className="rec-grid-12-12">
          {result}
          <Button
            className="rec-button-primary"
            title="check availability"
            onClick={() => this.setPermitType(target, needAuth)}
            disabled={buttonIsDisabled}
            aria-label="check availability">
            {buttonLabel}
          </Button>
        </div>
      </div>
    );
  }
}

MtWhitneyDayUsePermit.propTypes = {
  history: TYPES.HISTORY,
  pActions: PropTypes.object.isRequired,
  permit: PropTypes.object.isRequired,
  lotteries: PropTypes.array
};

export default withRouter(MtWhitneyDayUsePermit);
